import { FC } from "react";
import { Center, Text } from "@chakra-ui/react";

import { EFiltersAliasState } from "../../../../store/operationListFiltersStore.ts";

interface Props {
  filterAlias: EFiltersAliasState;
}

export const OperationListEmpty: FC<Props> = ({ filterAlias }) => {
  const message = filterAlias === EFiltersAliasState.Outflows
    ? "У вас нет трат"
    : "У вас нет поступлений";

  return (
    <Center flex="1" pb="100px">
      <Text variant="brand">{message}</Text>
    </Center>
  );
};
